import {toast} from 'materialize-css';
import Random from '../util/random';
import uploadFileViaAjax from './uploadFileViaAjax';
import {_} from "../util/dom";


class UploadService {
    constructor() {
        this.dropbox = null;
        this.uploadList = null;
        this.mediaList = null;

        this.handleFileDrop = this.handleFileDrop.bind(this);
        this.updateProgress = this.updateProgress.bind(this);
        this.updateComplete = this.updateComplete.bind(this);
        this.uploadFailed = this.uploadFailed.bind(this);

        this.eventHandlers = {
            'drop': [],
            'progressUpdate': [],
            'success': [],
            'error': [],
        };
    }

    // setup interface

    registerDropbox(dropbox) {
        this.dropbox = dropbox;

        if(!this.dropbox.onFileUpload) {
            this.dropbox.onFileUpload = this.handleFileDrop;
        }
        
        return this;
    }

    registerUploadList(uploadList) {
        this.uploadList = uploadList;
        return this;
    }

    registerMediaList(mediaList) {
        this.mediaList = mediaList;
        return this;
    }

    // event interface

    on(eventName, callback) {
        if(this.eventHandlers[eventName]) {
            this.eventHandlers[eventName].push(callback);
        }
        return this;
    }

    handle(eventName, ...args) {
        if(!this.eventHandlers[eventName]) {
            throw new Error("Cannot handle undefined event " + eventName);
        }
        this.eventHandlers[eventName].forEach(callback => callback(...args));
    }

    // event handlers

    handleFileDrop(fileList) {
        Array.from(fileList).forEach(file => {
            const uploadId = Random.string();
            // PLEASE ENSURE user.ini has file limits set to 100MB
            if (file.size < 101e6){
                this.uploadList.addFile(uploadId, file);

                let organizationId = parseInt(_('meta[name="current-organization"').content);


                const form = new FormData();
                form.append('file', file);
                form.append('upload_id', uploadId);
                form.append('organizationId', organizationId);
                form.append('_token', $('meta[name=csrf-token]').attr('content'));

                this.handle('drop', uploadId);

                uploadFileViaAjax(form, {
                    onProgress: this.updateProgress,
                    onSuccess: this.updateComplete,
                    onError: this.uploadFailed,
                });
            } else {
                alert("File is over 100MB, will not be uploaded: " + file.name);
            }

        })
    }

    updateProgress(evt, form) {
        if(!evt.lengthComputable) {
            return;
        }

        const uploadId = form.get('upload_id');
        const percent = 100 * (evt.loaded / evt.total);
        this.uploadList.updateProgress(uploadId, percent);
        this.handle('progressUpdate', uploadId);
    }

    updateComplete(form, res) {
        const uploadId = form.get('upload_id');

        if(res.error) {
            console.log("[updateComplete] ERROR", res.error);
        }

        this.uploadList.removeFile(uploadId);
        this.mediaList.addFile(res.key, res.filename);
        
        this.handle('success', res.key);
    }

    uploadFailed(form, jqxhr, status, errorMessage) {
        const uploadId = form.get('upload_id');

        console.log("[uploadFailed] err", {
            status,
            errorMessage,
        });
        toast("ERROR: " + errorMessage, 4000);
        this.uploadList.removeFile(uploadId);
        this.handle('error', uploadId);
    }
}


export default UploadService;